import { Helmet } from 'react-helmet';
import PasswordForm from '../../components/profile/PasswordForm';

const UpdatePassword = () => {
  return (
    <>
      <Helmet>
        <meta charSet="utf-8" />
        <title>Edit your Password - Global Triumph Market Plus Multiconcept</title>
        <meta
          name="description"
          content="User password editing page on Global Triumph Market Plus Multiconcept - Real estate investments and properties, properties for sales"
        />
      </Helmet>
      <div className="profile">
        <h1 className="pageTitle">Update Password</h1>
        <h3 className="subtitle">You can edit your account password here</h3>
        <PasswordForm />
      </div>
    </>
  );
};

export default UpdatePassword;
